import { render, staticRenderFns } from "./EditionLinks.vue?vue&type=template&id=b8a1e7c6&scoped=true"
import script from "./EditionLinks.vue?vue&type=script&lang=js"
export * from "./EditionLinks.vue?vue&type=script&lang=js"
import style0 from "./EditionLinks.vue?vue&type=style&index=0&id=b8a1e7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a1e7c6",
  null
  
)

export default component.exports